const styles = theme => ({
  dialogPaper: {
    width: "100%",
  },
  dialogTitle: {
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.primary.dark,
  },
  dialogContent: {
    padding: theme.spacing(2),
    paddingTop: [theme.spacing(2), "!important"],
    [theme.breakpoints.down("sm")]: {
      height: "inherit",
    },
  },
  dialogActions: {
    padding: theme.spacing(2),
    paddingTop: 0,
    margin: 0,
    position: "absolute",
    right: 0,
    bottom: 0,
  },
  headlineWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    minHeght: 32,
  },
  headline: {
    opacity: 0.6,
    fontSize: "1em",
    display: "inline",
  },
  updateHeadline: {
    opacity: 0.6,
    fontSize: "0.7em",
    display: "inline",
  },
  addCompanyLogoHeadline: {
    opacity: 0.8,
    fontSize: "0.8em",
    display: "inline",
    padding: theme.spacing(1),
  },
  inputWrapper: {
    display: "flex",
    alignItems: "baseline",
    marginBottom: theme.spacing(1),
  },
  autoComplete: {
    flexGrow: 1,
  },
  autoCompleteInput: {
    padding: "9px 0",
  },
  inputMarginBottom: {
    transform: "translateY(-14px)",
    zIndex: 1,
  },
  zIndex2: {
    zIndex: 2,
  },
  placesAutoCompleteInputInput: {
    "&::placeholder": {
      color: "#000",
      opacity: 0.42,
    },
  },
  input: {
    margin: `0 ${theme.spacing(1)}px`,
    flexBasis: 120,
  },
  citiesWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  closeButton: {
    width: 28,
    height: 28,
  },
  closeIcon: {
    width: "0.74em",
    height: "0.74em",
    color: "#ffffff",
  },
  chipWrapper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  chip: {
    marginRight: theme.spacing(1),
  },
  videoId: {
    color: theme.palette.primary.main,
  },
  button: {
    marginLeft: theme.spacing(2),
  },
  note: {
    display: "flex",
    borderBottom: "1px solid #9c9c9c",
    paddingBottom: 12,
    "&:not(:first-child)": {
      paddingTop: 12,
    },
  },
  lastNote: {
    marginBottom: theme.spacing(3),
  },
  noteContent: {
    flexGrow: "1",
    display: "flex",
    flexDirection: "column",
  },
  noteFirstLine: {
    display: "flex",
  },
  noteMessageIcon: {
    color: theme.palette.primary.dark,
    width: "0.7em",
    height: "0.7em",
  },
  noteLineText: {
    color: theme.palette.primary.dark,
    fontSize: "0.7em",
    lineHeight: "1.2em",
    padding: `0 ${theme.spacing(1)}px`,
  },
  noteLineArrowIcon: {
    width: "0.6em",
    height: "0.7em",
    cursor: "pointer",
  },
  noteBullet: {
    fontSize: "13px",
    opacity: "0.5",
    lineHeight: "1.2em",
  },
  noteTimeAgo: {
    color: "rgba(0, 0, 0, 0.5)",
    fontSize: "12px",
    padding: "0 6px",
    lineHeight: "1.3em",
  },
  noteNote: {
    color: theme.palette.text.secondary,
  },
  noteAvatar: {
    alignSelf: "center",
  },
  notesInputWrapper: {
    // backgroundColor: "#f1f1f1",
    padding: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
    alignItems: "flex-end",
    borderBottom: "1px solid #000000",
  },
  noteInputUnderline: {
    "&:before": {
      borderBottom: ["none", "!important"],
    },
    "&:after": {
      borderBottom: ["none", "!important"],
    },
  },
  saveNoteButton: {
    alignSelf: "flex-end",
  },
  textColor: {
    color: "#ffffff",
  },
  backgroundDim: { backgroundColor: "#f6f6fe" },
  paddingTop: { paddingTop: theme.spacing(2), paddingBottom: theme.spacing(2) },
  checkbox: { color: theme.palette.primary.dark },
  imageOverlay: {
    "&:before": {
      position: "absolute",
      zIndex: 1,
      top: "0",
      left: "0",
      bottom: "0",
      right: "0",
      color: "white",
      textTransform: "uppercase",
      fontWeight: "500",
      fontFamily: "Roboto",
      fontSize: "24px",
      padding: "12px",
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
    },
  },
  avatarWrapper: {
    width: "100%",
    // paddingTop: "100%",
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      opacity: 1,
    },
    "&:hover $addImageOverlay": {
      opacity: 1,
    },
  },
  avatarPaper: {
    position: "relative",
  },
  avatarUploadOverlay: {
    position: "absolute",
    top: 50,
    left: 0,
    zIndex: "1",
    backgroundColor: theme.palette.action.active,
    height: "30%",
    width: "30%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "wait",
  },
  avatarImage: {
    width: "30%",
    top: 0,
    left: 0,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.grey[400],
  },
  avatar: {
    width: "100px",
    height: "100px",
    top: 5,
    left: 5,
    position: "absolute",
    borderRadius: 0,
    fontSize: "4em",
    fontFamily: '"Oswald"',
    backgroundColor: theme.palette.grey[400],
  },
  avatarLabel: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    cursor: "pointer",
  },
  avatarInput: {
    opacity: 0,
    outline: "none",
  },
  addImageOverlay: {
    position: "absolute",
    top: 50,
    left: 0,
    zIndex: "1",
    backgroundColor: theme.palette.action.disabled,
    height: "30%",
    width: "30%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    cursor: "pointer",
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.easeInOut,
    }),
    [theme.breakpoints.down("sm")]: {
      opacity: 1,
    },
  },
  addPhotoIcon: {
    color: "#fff",
    width: "1.6em",
    height: "1.6em",
  },
  mobileForm: {
    [theme.breakpoints.down("sm")]: {
      height: "100%",
    },
  },
})

export default styles
